import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect, useState, useCallback } from 'react';
import { FeatureGate } from '../interfaces/FeatureGate';

export const useIsFeatureEnabled = (featureGate: FeatureGate): boolean => {
  const { client } = useStatsigClient();
  const [isEnabled, setIsEnabled] = useState<boolean>(false);

  const checkGate = useCallback(() => {
    if (client) {
      try {
        const status = client.checkGate(featureGate);
        setIsEnabled(status);
      } catch (err) {
        console.error(`Error checking feature gate ${featureGate}:`, err);
        setIsEnabled(false);
      }
    }
  }, [client, featureGate]);

  useEffect(() => {
    checkGate();
  }, [checkGate]);

  return isEnabled;
};
